import React from "react";
import "./portal.scss";
import ProductList from "../Shop/ProductList";

const SanPham = () => {
  return <ProductList />;
};

export default SanPham;


